import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import OrderForm from "./pages/OrderForm";
import OrderDetail from "./pages/OrderDetail";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Monitor from "./pages/Monitor";
import Visits from "./pages/Visits";
import Users from "./pages/Users";
import Reports from "./pages/Reports";

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]" data-testid="app-loading">
      <div className="flex items-center justify-center">
        <img src="/logo.png" alt="SoloSoporte" className="h-12 w-auto animate-pulse object-contain" />
      </div>
    </div>
  );
}

function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/orders/new" element={<OrderForm />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/orders/:id/edit" element={<OrderForm />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/monitor" element={<Monitor />} />
              <Route path="/visits" element={<Visits />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/users" element={<RequireAdmin><Users /></RequireAdmin>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
